import { encodeParams } from "mailup-react-helpers";

import apiWrapper from "Helpers/apiWrapper";

import type {
  AddRecipientResult,
  CheckNameIn,
  CheckNameOut,
  ClusterCount,
  ConfidentialsResponseItem,
  CopyGroupToListsRequest,
  DeleteGroupRecipientsQsParams,
  DeleteImportsRequest,
  DeletedGroupsResponse,
  EmailSubscriptionOut,
  EmptyGroupsIn,
  EntityUsingItem,
  ExitFromAnyOptoutTypeQsParam,
  FindAndReplaceIn,
  FindAndReplaceResponse,
  GenericTaskResponse,
  GetListOfGroupDetailsQsParams,
  GetMultipleRecipientGroupsByListIn,
  GetMultipleRecipientGroupsByListOut,
  GetMultipleRecipientGroupsByListQsParams,
  GetRunningImportResp,
  GroupDetails,
  GroupIn,
  GroupOverlapRequest,
  GroupOverlapResponse,
  GroupSubscribersStatisticsOut,
  ImportFilesConfigRequest,
  ImportFilesConfigResponse,
  GetDefaultMappingResponse,
  ImportFilesPreviewRequest,
  ImportFilesPreviewResponse,
  ImportsResp,
  ListSubscriptionCounterOut,
  OptInDataIn,
  OptInMultiListData,
  OptInMultiListDataIn,
  OptOutDataIn,
  OptOutMultiListDataIn,
  OptOutMultiListDataOut,
  OptOutTypeCount,
  OptinEmailRecipientFromListQsParams,
  OptinSmsRecipientFromListQsParams,
  OptoutEmailRecipientFromListQsParams,
  OptoutRecipientFromMultiListsQsParams,
  OptoutSmsRecipientFromListQsParams,
  PagedListOfGroupDetails,
  PendingDataIn,
  PendingMultiListDataIn,
  PendingSmsDataIn,
  ReSendIn,
  RecipientContactsIn,
  RecipientContactsOut,
  RecipientIn,
  RecipientProfile,
  SearchImportsData,
  SearchImportsRequest,
  SearchImportsResp,
  SegmentationResponse,
  SegmmentRecipientsToGroupCustomParams,
  SetEmailRecipientTrackingRequest,
  SimulateSegmentRecipientsToGroupIn,
  SimulateSegmentRecipientsToGroupOut,
  SmsSubscriptionOut,
  SubscriptionStatusQsParam,
  TrackingResponse,
  GetEmailRecipientTrackingMostRecentChangeLogResponse,
  GetEmailRecipientTrackingChangeLogsQsParams,
  GetEmailRecipientTrackingChangeLogsResponse,
  WebhookSourceQsParam,
  ImportFilesConfigFieldMapping,
  CopyPasteExtractorRequest,
  CopyPasteExtractorResponse,
} from "Types/beRecipientsApi";

const endpoints = ((baseURL: string) => {
  return {
    //  AsyncOperations
    findAndReplace: (idList: number) => `${baseURL}/api/replace/list/${idList}`,
    findAndReplaceSimulation: (idList: number) =>
      `${baseURL}/api/replacesimulation/list/${idList}`,
    //  SubscriptionEmail

    getSubscriptionEmailFromList: (idRecipient: number, idList: number) =>
      `${baseURL}/api/email/recipients/${idRecipient}/subscription/list/${idList}`,

    getEmailListSubscriptionCounters: (idList: number) =>
      `${baseURL}/api/email/list/${idList}/counters`,

    getAllSubscriptionsEmailFromList: (idRecipient: number) =>
      `${baseURL}/api/email/recipients/${idRecipient}/subscriptions`,

    optinEmailRecipientFromMultiLists: (
      idRecipient: number,
      qsParams: WebhookSourceQsParam & ExitFromAnyOptoutTypeQsParam,
    ) =>
      `${baseURL}/api/email/recipients/${idRecipient}/subscription/optin?${
        encodeParams(qsParams) as string
      }`,

    optoutEmailRecipientFromMultiLists: (
      idRecipient: number,
      qsParams: OptoutRecipientFromMultiListsQsParams,
    ) =>
      `${baseURL}/api/email/recipients/${idRecipient}/subscription/optout?${
        encodeParams(qsParams) as string
      }`,

    pendingEmailRecipientFromMultiLists: (
      idRecipient: number,
      qsParams: WebhookSourceQsParam & ExitFromAnyOptoutTypeQsParam,
    ) =>
      `${baseURL}/api/email/recipients/${idRecipient}/subscription/pending?${
        encodeParams(qsParams) as string
      }`,

    optinEmailRecipientFromList: (
      idRecipient: number,
      idList: number,
      qsParams: OptinEmailRecipientFromListQsParams,
    ) =>
      `${baseURL}/api/email/recipients/${idRecipient}/subscription/list/${idList}/optin?${
        encodeParams(qsParams) as string
      }`,
    pendingEmailRecipientFromList: (
      idRecipient: number,
      idList: number,
      qsParams: WebhookSourceQsParam,
    ) =>
      `${baseURL}/api/email/recipients/${idRecipient}/subscription/list/${idList}/pending?${
        encodeParams(qsParams) as string
      }`,
    optoutEmailRecipientFromList: (
      idRecipient: number,
      idList: number,
      qsParams: OptoutEmailRecipientFromListQsParams,
    ) =>
      `${baseURL}/api/email/recipients/${idRecipient}/subscription/list/${idList}/optout?${
        encodeParams(qsParams) as string
      }`,
    reSend: (idRecipient: number, idList: number) =>
      `${baseURL}/api/recipients/${idRecipient}/list/${idList}/resend`,

    simulateSegmentRecipientGroupName: (idList: number) =>
      `${baseURL}/api/recipient/list/${idList}/segmentation/simulate`,
    segmentRecipientByCustomSearch: (idList: number) =>
      `${baseURL}/api/recipient/list/${idList}/segmentation/customsearchparams`,

    //  SubscriptionSms
    getSmsSubscriptionFromList: (idRecipient: number, idList: number) =>
      `${baseURL}/api/sms/recipients/${idRecipient}/subscription/list/${idList}`,
    getSmsListSubscriptionCounters: (idList: number) =>
      `${baseURL}/api/sms/list/${idList}/counters`,
    getAllSubscriptionsSmsFromList: (idRecipient: number) =>
      `${baseURL}/api/sms/recipients/${idRecipient}/subscriptions`,

    optinSmsRecipientFromMultiLists: (
      idRecipient: number,
      qsParams: WebhookSourceQsParam & ExitFromAnyOptoutTypeQsParam,
    ) =>
      `${baseURL}/api/sms/recipients/${idRecipient}/subscription/optin?${
        encodeParams(qsParams) as string
      }`,

    optoutSmsRecipientFromMultiLists: (
      idRecipient: number,
      qsParams: OptoutRecipientFromMultiListsQsParams,
    ) =>
      `${baseURL}/api/sms/recipients/${idRecipient}/subscription/optout?${
        encodeParams(qsParams) as string
      }`,

    optinSmsRecipientFromList: (
      idRecipient: number,
      idList: number,
      qsParams: OptinSmsRecipientFromListQsParams,
    ) =>
      `${baseURL}/api/sms/recipients/${idRecipient}/subscription/list/${idList}/optin?${
        encodeParams(qsParams) as string
      }`,

    pendingSmsRecipientFromList: (idRecipient: number, idList: number) =>
      `${baseURL}/api/sms/recipients/${idRecipient}/subscription/list/${idList}/pending`,
    optoutSmsRecipientFromList: (
      idRecipient: number,
      idList: number,
      qsParams: OptoutSmsRecipientFromListQsParams,
    ) =>
      `${baseURL}/api/sms/recipients/${idRecipient}/subscription/list/${idList}/optout?${
        encodeParams(qsParams) as string
      }`,

    //  Groups
    getEntitiesUsingGroup: (idGroup: number) =>
      `${baseURL}/api/groups/${idGroup}/entities`,
    getListOfGroupDetails: (
      idList: number,
      qsParams: GetListOfGroupDetailsQsParams,
    ) =>
      `${baseURL}/api/list/${idList}/groups?${
        encodeParams(qsParams) as string
      }`,
    getGroupDetails: (idGroup: number) => `${baseURL}/api/groups/${idGroup}`,

    getMultipleRecipientGroupsByList: (
      qsParams: GetMultipleRecipientGroupsByListQsParams,
    ) =>
      `${baseURL}/api/recipients/assignements?${
        encodeParams(qsParams) as string
      }`,

    deleteGroup: (idGroup: number) => `${baseURL}/api/groups/${idGroup}`,
    emptyGroups: (idList: number) =>
      `${baseURL}/api/list/${idList}/groups/empty`,
    deleteGroups: `${baseURL}/api/groups/delete`,
    deleteGroupsAndRecipients: `${baseURL}/api/groups/recipients/delete`,
    addGroup: `${baseURL}/api/groups`,
    updateGroup: (idGroup: number) => `${baseURL}/api/groups/${idGroup}`,
    checkIfGroupNameExists: (idList: number) =>
      `${baseURL}/api/list/${idList}/groups/checkname`,
    getGroupsStats: `${baseURL}/api/groups/statistics`,
    deleteGroupRecipients: (
      idGroup: number,
      qsParams: DeleteGroupRecipientsQsParams,
    ) =>
      `${baseURL}/api/group/${idGroup}/recipients?${
        encodeParams(qsParams) as string
      }`,
    getGroupsOverlapRecipients: `${baseURL}/api/group/email/overlaps`,
    copyGroupToLists: `${baseURL}/api/subscriptions/copy`,
    //
    addRecipient: (
      idList: number,
      qsParams: WebhookSourceQsParam & SubscriptionStatusQsParam,
    ) =>
      `${baseURL}/api/list/${idList}/recipient?${
        encodeParams(qsParams) as string
      }`,
    hasRecipients: (idList: number) =>
      `${baseURL}/api/list/${idList}/hasrecipients`,
    getRecipient: (idRecipient: number) =>
      `${baseURL}/api/recipients/${idRecipient}`,

    updateRecipientContacts: (idList: number, idRecipient: number) =>
      `${baseURL}/api/list/${idList}/recipients/${idRecipient}/contacts`,

    //  Confidentials
    getLoginConfidentialDefinitions: (idLogin: number) =>
      `${baseURL}/api/login/${idLogin}/confidentials`,
    //  Statistics
    getUnsubscriptionGroupedByCounter: (idList: number) =>
      `${baseURL}/api/email/list/${idList}/stats/unsubscription/optouttype`,

    //  Engagement
    getClusterCounter: (idList: number, qsParams: any) =>
      `${baseURL}/api/list/${idList}/recipients/clustercounter?${
        encodeParams(qsParams) as string
      }`,

    // Tracking
    getEmailRecipientTracking: (idRecipient: number, idList: number) =>
      `${baseURL}/api/email/recipients/${idRecipient}/tracking/list/${idList}`,
    setEmailRecipientTracking: (idRecipient: number, idList: number) =>
      `${baseURL}/api/email/recipients/${idRecipient}/tracking/list/${idList}`,
    getEmailRecipientTrackingMostRecentChangeLog: (
      idRecipient: number,
      idList: number,
    ) =>
      `${baseURL}/api/email/recipients/${encodeURIComponent(idRecipient)}/tracking/list/${encodeURIComponent(idList)}/changelogs/mostrecent`,
    getEmailRecipientTrackingChangeLogs: (
      idRecipient: number,
      idList: number,
      qsParams: GetEmailRecipientTrackingChangeLogsQsParams,
    ) =>
      `${baseURL}/api/email/recipients/${encodeURIComponent(idRecipient)}/tracking/list/${encodeURIComponent(idList)}/changelogs?${encodeParams(qsParams) as string}`,

    //import
    searchImports: (idList: number, qsParams: any) =>
      `${baseURL}/api/list/${idList}/import/search?${
        encodeParams(qsParams) as string
      }`,
    deleteImports: (idList: number) =>
      `${baseURL}/api/list/${idList}/import/delete`,
    deleteImport: (idList: number, idImport: number) =>
      `${baseURL}/api/list/${idList}/import/${idImport}/delete`,
    startImport: (idList: number) =>
      `${baseURL}/api/list/${idList}/import/start`,
    stopImport: (idList: number) => `${baseURL}/api/list/${idList}/import/stop`,
    getRunningImport: () => `${baseURL}/api/import/running`,
    previewImportFile: (idList: number, fileName: string) =>
      `${baseURL}/api/list/${idList}/import/files/${encodeURIComponent(fileName)}/preview`,
    saveImportConfiguration: (idList: number, fileName: string) =>
      `${baseURL}/api/list/${idList}/import/files/${encodeURIComponent(fileName)}/config`,
    getDefaultMapping: (idList: number) =>
      `${baseURL}/api/list/${idList}/import/mapping/default`,
    copyPasteExtractor: (idList: number) =>
      `${baseURL}/api/list/${idList}/import/copypaste/extract`,
  };
})(process.env.BERECIPIENT_URL as string);

export const beRecipientGetSubscriptionEmailFromList = async (
  idRecipient: number,
  idList: number,
): Promise<EmailSubscriptionOut> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getSubscriptionEmailFromList(idRecipient, idList),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientGetSmsSubscriptionFromList = async (
  idRecipient: number,
  idList: number,
): Promise<SmsSubscriptionOut> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getSmsSubscriptionFromList(idRecipient, idList),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiOptoutEmailRecipientFromMultiLists = async (
  idRecipient: number,
  qsParams: OptoutRecipientFromMultiListsQsParams,
  dataIn: OptOutMultiListDataIn,
): Promise<OptOutMultiListDataOut> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.optoutEmailRecipientFromMultiLists(idRecipient, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiOptoutSmsRecipientFromMultiLists = async (
  idRecipient: number,
  qsParams: OptoutRecipientFromMultiListsQsParams,
  dataIn: OptOutMultiListDataIn,
): Promise<OptOutMultiListDataOut> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.optoutSmsRecipientFromMultiLists(idRecipient, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

//
export const beRecipientApiGetAllSubscriptionsEmailFromList = async (
  idRecipient: number,
): Promise<EmailSubscriptionOut[]> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getAllSubscriptionsEmailFromList(idRecipient),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiGetAllSubscriptionsSmsFromList = async (
  idRecipient: number,
): Promise<SmsSubscriptionOut[]> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getAllSubscriptionsSmsFromList(idRecipient),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

//  Async operation
export const beRecipientApiFindAndReplace = async (
  idList: number,
  dataIn: FindAndReplaceIn,
): Promise<FindAndReplaceResponse> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.findAndReplace(idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiFindAndReplaceSimulation = async (
  idList: number,
  dataIn: FindAndReplaceIn,
): Promise<FindAndReplaceResponse> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.findAndReplaceSimulation(idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

//  SubscriptionEmail
export const beRecipientApiOptinEmailRecipientFromList = async (
  idRecipient: number,
  idList: number,
  qsParams: OptinEmailRecipientFromListQsParams,
  dataIn: OptInDataIn,
): Promise<boolean> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.optinEmailRecipientFromList(idRecipient, idList, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiPendingEmailRecipientFromList = async (
  idRecipient: number,
  idList: number,
  qsParams: WebhookSourceQsParam,
  dataIn: PendingDataIn,
): Promise<boolean> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.pendingEmailRecipientFromList(idRecipient, idList, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiOptoutEmailRecipientFromList = async (
  idRecipient: number,
  idList: number,
  qsParams: OptoutEmailRecipientFromListQsParams,
  dataIn: OptOutDataIn,
): Promise<boolean> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.optoutEmailRecipientFromList(idRecipient, idList, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiReSend = async (
  idRecipient: number,
  idList: number,
  dataIn: ReSendIn,
): Promise<boolean> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.reSend(idRecipient, idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

//  SubscriptionSMS
export const beRecipientApiOptinSmsRecipientFromList = async (
  idRecipient: number,
  idList: number,
  qsParams: OptinSmsRecipientFromListQsParams,
  dataIn: OptInDataIn,
): Promise<boolean> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.optinSmsRecipientFromList(idRecipient, idList, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiPendingSmsRecipientFromList = async (
  idRecipient: number,
  idList: number,
  dataIn: PendingSmsDataIn,
): Promise<boolean> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.pendingSmsRecipientFromList(idRecipient, idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiOptoutSmsRecipientFromList = async (
  idRecipient: number,
  idList: number,
  qsParams: OptoutSmsRecipientFromListQsParams,
  dataIn: OptOutDataIn,
): Promise<boolean> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.optoutSmsRecipientFromList(idRecipient, idList, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiOptinEmailRecipientFromMultiLists = async (
  idRecipient: number,
  qsParams: WebhookSourceQsParam & ExitFromAnyOptoutTypeQsParam,
  dataIn: OptInMultiListDataIn,
): Promise<OptInMultiListData[]> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.optinEmailRecipientFromMultiLists(idRecipient, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiOptinSmsRecipientFromMultiLists = async (
  idRecipient: number,
  qsParams: WebhookSourceQsParam & ExitFromAnyOptoutTypeQsParam,
  dataIn: OptInMultiListDataIn,
): Promise<OptInMultiListData[]> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.optinSmsRecipientFromMultiLists(idRecipient, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiPendingEmailRecipientFromMultiLists = async (
  idRecipient: number,
  qsParams: WebhookSourceQsParam & ExitFromAnyOptoutTypeQsParam,
  dataIn: PendingMultiListDataIn,
): Promise<OptInMultiListData[]> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.pendingEmailRecipientFromMultiLists(idRecipient, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiGetMultipleRecipientGroupsByList = async (
  qsParams: GetMultipleRecipientGroupsByListQsParams,
  dataIn: GetMultipleRecipientGroupsByListIn,
): Promise<GetMultipleRecipientGroupsByListOut> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.getMultipleRecipientGroupsByList(qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiGetListOfGroupDetails = async (
  idList: number,
  qs: GetListOfGroupDetailsQsParams,
): Promise<PagedListOfGroupDetails> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getListOfGroupDetails(idList, qs),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiGetGroupDetails = async (
  idGroup: number,
): Promise<GroupDetails> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getGroupDetails(idGroup),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiGetEntitiesUsingGroup = async (
  idGroup: number,
): Promise<EntityUsingItem[]> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getEntitiesUsingGroup(idGroup),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiDeleteGroup = async (
  idGroup: number,
): Promise<boolean[]> => {
  return await apiWrapper({
    method: "delete",
    url: endpoints.deleteGroup(idGroup),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiEmptyGroups = async (
  idList: number,
  dataIn: EmptyGroupsIn,
): Promise<boolean[]> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.emptyGroups(idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiDeleteGroups = async (
  Ids: number[],
): Promise<DeletedGroupsResponse[]> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.deleteGroups,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ Ids }),
  }).then(({ data }) => data);
};

/**
 * deletes recipients belongings to specified groups and possibly the groups themselves
 * @param groupsIds
 * @param onlyUsers if true deletes only recipients, if false deletes both recipients and groups
 * @returns
 */
export const beRecipientApiDeleteGroupsRecipients = async (
  groupsIds: number[],
  onlyUsers: boolean,
): Promise<DeletedGroupsResponse[]> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.deleteGroupsAndRecipients,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ Ids: groupsIds, onlyUsers }),
  }).then(({ data }) => data);
};

export const beRecipientApiAddGroup = async (
  dataIn: GroupIn,
): Promise<GroupDetails> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.addGroup,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiUpdateGroup = async (
  idGroup: number,
  dataIn: GroupIn,
): Promise<GroupDetails> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.updateGroup(idGroup),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiCheckIfGroupNameExists = async (
  idList: number,
  dataIn: CheckNameIn,
): Promise<CheckNameOut> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.checkIfGroupNameExists(idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiGetGroupsStats = async (
  groupsIds: number[],
): Promise<GroupSubscribersStatisticsOut[]> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.getGroupsStats,
    data: JSON.stringify(groupsIds),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiDeleteGroupRecipients = async (
  idGroup: number,
  qsParams: DeleteGroupRecipientsQsParams,
): Promise<GenericTaskResponse> => {
  return await apiWrapper({
    method: "delete",
    url: endpoints.deleteGroupRecipients(idGroup, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiGetGroupsOverlapRecipients = async (
  dataIn: GroupOverlapRequest,
): Promise<GroupOverlapResponse[]> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.getGroupsOverlapRecipients,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

//

export const beRecipientApiAddRecipient = async (
  idList: number,
  qsParams: WebhookSourceQsParam & SubscriptionStatusQsParam,
  dataIn: RecipientIn,
): Promise<AddRecipientResult> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.addRecipient(idList, qsParams),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiGetRecipient = async (
  idRecipient: number,
): Promise<RecipientProfile> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getRecipient(idRecipient),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiGetLoginConfidentialDefinitions = async (
  idUser: number,
): Promise<ConfidentialsResponseItem[]> => {
  return await apiWrapper({
    url: endpoints.getLoginConfidentialDefinitions(idUser),
  }).then(({ data }) => data);
};

export const beRecipientApiUpdateRecipientContacts = async (
  idList: number,
  idRecipient: number,
  data: RecipientContactsIn,
): Promise<RecipientContactsOut> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.updateRecipientContacts(idList, idRecipient),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  }).then(({ data }) => data);
};

export const beRecipientApiHasRecipients = async (
  idList: number,
): Promise<boolean> => {
  return await apiWrapper({
    url: endpoints.hasRecipients(idList),
  }).then(({ data }) => data);
};

//

export const beRecipientApiGetEmailListSubscriptionCounters = async (
  idList: number,
): Promise<ListSubscriptionCounterOut> => {
  return await apiWrapper({
    url: endpoints.getEmailListSubscriptionCounters(idList),
  }).then(({ data }) => data);
};

export const beRecipientApiGetSmsListSubscriptionCounters = async (
  idList: number,
): Promise<ListSubscriptionCounterOut> => {
  return await apiWrapper({
    url: endpoints.getSmsListSubscriptionCounters(idList),
  }).then(({ data }) => data);
};

export const beRecipientApiGetUnsubscriptionGroupedByCounter = async (
  idList: number,
): Promise<OptOutTypeCount[]> => {
  return await apiWrapper({
    url: endpoints.getUnsubscriptionGroupedByCounter(idList),
  }).then(({ data }) => data);
};

export const beRecipientApiGetClusterCounter = async (
  idList: number,
  status: Array<"Subscribed" | "Pending" | "Unsubscribed">,
  dataIn: any = {},
): Promise<ClusterCount[]> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.getClusterCounter(idList, { status: status.join(",") }),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiSearchImports = async (
  idList: number,
  dataIn: SearchImportsData,
  requestBody: SearchImportsRequest,
): Promise<SearchImportsResp> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.searchImports(idList, dataIn),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(requestBody),
  }).then(({ data }) => data);
};

export const beRecipientApiDeleteImports = async (
  idList: number,
  requestBody: DeleteImportsRequest,
): Promise<ImportsResp> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.deleteImports(idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(requestBody),
  }).then(({ data }) => data);
};

export const beRecipientApiDeleteImport = async (
  idList: number,
  idImport: number,
): Promise<ImportsResp> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.deleteImport(idList, idImport),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiStartImports = async (
  idList: number,
): Promise<ImportsResp> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.startImport(idList),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiStopImports = async (
  idList: number,
): Promise<ImportsResp> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.stopImport(idList),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiGetRunningImport =
  async (): Promise<GetRunningImportResp> => {
    return await apiWrapper({
      method: "get",
      url: endpoints.getRunningImport(),
      headers: {
        "Content-Type": "application/json",
      },
    }).then(({ data }) => data);
  };

export const beRecipientApiGetEmailRecipientTracking = async (
  idRecipient: number,
  idList: number,
): Promise<TrackingResponse> => {
  return await apiWrapper({
    url: endpoints.getEmailRecipientTracking(idRecipient, idList),
  }).then(({ data }) => data);
};

export const beRecipientApiGetEmailRecipientTrackingMostRecentChangeLog =
  async (
    idRecipient: number,
    idList: number,
  ): Promise<GetEmailRecipientTrackingMostRecentChangeLogResponse> => {
    return await apiWrapper({
      url: endpoints.getEmailRecipientTrackingMostRecentChangeLog(
        idRecipient,
        idList,
      ),
    }).then(({ data }) => data);
  };

export const beRecipientApiGetEmailRecipientTrackingChangeLogs = async (
  idRecipient: number,
  idList: number,
  qsParams: GetEmailRecipientTrackingChangeLogsQsParams,
): Promise<GetEmailRecipientTrackingChangeLogsResponse> => {
  return await apiWrapper({
    url: endpoints.getEmailRecipientTrackingChangeLogs(
      idRecipient,
      idList,
      qsParams,
    ),
  }).then(({ data }) => data);
};

export const beRecipientApiSetEmailRecipientTracking = async (
  idRecipient: number,
  idList: number,
  dataIn: SetEmailRecipientTrackingRequest,
): Promise<void> => {
  return await apiWrapper({
    method: "put",
    url: endpoints.setEmailRecipientTracking(idRecipient, idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiSegmentRecipientByCustomSearch = async (
  idList: number,
  dataIn: SegmmentRecipientsToGroupCustomParams,
): Promise<SegmentationResponse> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.segmentRecipientByCustomSearch(idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiSimulateSegmentRecipientGroupName = async (
  idList: number,
  dataIn: SimulateSegmentRecipientsToGroupIn,
): Promise<SimulateSegmentRecipientsToGroupOut> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.simulateSegmentRecipientGroupName(idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data);
};

export const beRecipientApiCopyGroupToLists = async (
  req: CopyGroupToListsRequest,
): Promise<GenericTaskResponse> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.copyGroupToLists,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(req),
  }).then(({ data }) => data);
};

export const beRecipientApiGetDefaultMapping = async (
  idList: number,
): Promise<GetDefaultMappingResponse> => {
  return await apiWrapper({
    method: "get",
    url: endpoints.getDefaultMapping(idList),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

export const beRecipientApiPreviewImportFile = async (
  idList: number,
  fileName: string,
  req: ImportFilesPreviewRequest,
): Promise<ImportFilesPreviewResponse> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.previewImportFile(idList, fileName),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(req),
  }).then(({ data }) => data);
};

export const beRecipientApiSaveImportConfiguration = async (
  idList: number,
  fileName: string,
  req: ImportFilesConfigRequest,
): Promise<ImportFilesConfigResponse> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.saveImportConfiguration(idList, fileName),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(req),
  }).then(({ data }) => data);
};

export const beRecipientApiCopyPasteExtractor = async (
  idList: number,
  req: CopyPasteExtractorRequest,
): Promise<CopyPasteExtractorResponse> => {
  return await apiWrapper({
    method: "post",
    url: endpoints.copyPasteExtractor(idList),
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(req),
  }).then(({ data }) => data);
};
